import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id) {
  return yield oncallFetch("/api/oncall/partners/regions/get-by-id", { id });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/regions/get-by-id.js